<!-- 
  © 2025 Ananda Kumar. All rights reserved.
  Unauthorized copying of this file, via any medium, is strictly prohibited.
-->
<div class="modal fade show d-block" tabindex="-1" role="dialog" style="background-color: rgba(0, 0, 0, 0.5);">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content shadow rounded-4">
      <div class="modal-header mb-0 pb-2 border-0">
        <span class="modal-title mb-0">
          <h5 class="mb-0 pb-0">{{headerText}}</h5>
        </span>
        <button type="button" class="btn-close" (click)="cancel()"></button>
      </div>
      <p class="text-muted small ms-3">{{headerSubText}}</p>
      <div class="modal-body text-center">
        <div class="alert alert-warning small text-start px-3 py-2 rounded-3" role="alert">
          <strong>Note:</strong> Max of 10 images can be uploaded at once.<br />
          Only files with extensions <code>.jpeg</code>, <code>.jpg</code>, or <code>.png</code> are accepted.
        </div>

        <input type="file" #fileInput multiple accept=".png, .jpg, .jpeg, image/png, image/jpeg"
          (change)="onFileSelected($event)" hidden>

        <div class="input-group mb-3" (click)="fileInput.click()" style="cursor: pointer;">
          <input type="text" class="form-control" placeholder="Choose images" readonly>
          <span class="input-group-text">
            <i class="fas fa-upload t-icon"></i>
          </span>
        </div>

        <div *ngIf="selectedFiles.length > 0" class="text-start">
          <ul class="list-unstyled">
            <li *ngFor="let file of selectedFiles; let i = index" class="d-flex align-items-center mb-2">
              <div *ngIf="file.preview" class="me-2">
                <img [src]="file.preview" alt="Preview" class="rounded"
                  style="height: 40px; width: 40px; object-fit: cover;">
              </div>
              <span class="me-auto">{{ file.file.name }}</span>
              <button type="button" class="btn btn-sm btn-outline-danger" (click)="removeFile(i)">
                <i class="fas fa-times"></i>
              </button>
            </li>
          </ul>
        </div>

      </div>
      <div class="modal-footer border-0 d-flex justify-content-center">
        <button class="t-btn-primary px-5 py-2 text-white w-100" (click)="onUploadClick()">
          Upload Images
        </button>
      </div>
    </div>
  </div>
</div>

<div class="modal-backdrop fade show"></div>